module.exports = __webpack_public_path__ + "img/T5-A-xh_18.c56fca61.png";